module.exports = __webpack_public_path__ + "media/zapsplat_office_typewriter_carriage_return_margin_bell_vintage_1960_lemair_helvetia_001_40992.b226feec.mp3";